// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sidebar .virtual-table {
  flex: 1 100 100%;
}

.filelist.session .browser,
.filelist.session .browser .virtual-table {
  height: calc(100% - 35px);
}

#mobile-layout .filelist.session .browser {
  height: 100%;
}

#mobile-layout .filelist.session .browser {
  height: calc(100% - 10px);
}

@media screen and (min-color-index: 0) and(-webkit-min-device-pixel-ratio:0) {
  /* Safari specific CSS */
  .filelist.session .browser {
    height: calc(100% - 95px);
  }

  #mobile-layout .filelist.session .browser {
    height: calc(100% - 60px);
  }
}

.filelist.session .browser .ui.segment {
  margin-bottom: 10px;
}

.filelist.session {
  max-height: 100%;
  overflow: hidden;
  margin-top: 10px;
  flex: 1 1 100%;
}

.session.new .profile.ui.dropdown {
  margin-top: 10px;
  color: gray;
  align-self: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/routes/Sidebar/routes/Filelists/style.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB","sourcesContent":["#sidebar .virtual-table {\n  flex: 1 100 100%;\n}\n\n.filelist.session .browser,\n.filelist.session .browser .virtual-table {\n  height: calc(100% - 35px);\n}\n\n#mobile-layout .filelist.session .browser {\n  height: 100%;\n}\n\n#mobile-layout .filelist.session .browser {\n  height: calc(100% - 10px);\n}\n\n@media screen and (min-color-index: 0) and(-webkit-min-device-pixel-ratio:0) {\n  /* Safari specific CSS */\n  .filelist.session .browser {\n    height: calc(100% - 95px);\n  }\n\n  #mobile-layout .filelist.session .browser {\n    height: calc(100% - 60px);\n  }\n}\n\n.filelist.session .browser .ui.segment {\n  margin-bottom: 10px;\n}\n\n.filelist.session {\n  max-height: 100%;\n  overflow: hidden;\n  margin-top: 10px;\n  flex: 1 1 100%;\n}\n\n.session.new .profile.ui.dropdown {\n  margin-top: 10px;\n  color: gray;\n  align-self: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
